// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Shared toolbar styles for app-basic-filter (ViewEncapsulation.None).
   Page grid / drawer layout lives in listing-browse.component.scss. */
.basic-filter-toolbar {
  display: flex;
  flex-wrap: nowrap;
  align-items: center;
  gap: 8px;
  margin: 0;
  padding: 4px 8px;
  min-height: 48px;
}

.basic-filter-toolbar .keyword-search-field {
  flex: 1 1 auto;
  min-width: 0;
  padding: 0;
}

.basic-filter-toolbar .keyword-field-compact {
  width: 100%;
}

/* Collapse Material field chrome to one compact row. */
.basic-filter-toolbar .keyword-field-compact.mat-mdc-form-field {
  --mat-form-field-container-height: 40px;
  --mat-form-field-container-vertical-padding: 8px;
}

.basic-filter-toolbar .keyword-field-compact .mat-mdc-form-field-subscript-wrapper {
  display: none;
}

.basic-filter-toolbar .keyword-field-compact .mat-mdc-text-field-wrapper {
  padding-bottom: 0;
}

.basic-filter-toolbar .keyword-field-compact .mat-mdc-form-field-infix {
  min-height: 40px;
  padding-top: 8px;
  padding-bottom: 8px;
}

.basic-actions {
  display: flex;
  flex-wrap: nowrap;
  align-items: center;
  justify-content: flex-end;
  gap: 4px;
  flex: 0 0 auto;
  margin: 0 !important;
  padding: 0 !important;
  white-space: nowrap;
}

.all-filters-btn {
  margin-left: 0;
  line-height: 1.2;
  min-height: 36px;
  height: 36px;
  padding: 0 10px;
}
.all-filters-btn .mat-icon {
  font-size: 18px;
  width: 18px;
  height: 18px;
  margin-right: 4px;
  vertical-align: middle;
}

.all-filters-btn.sidebar-mode-active {
  background: var(--brand-button-soft, rgba(37, 99, 235, 0.18));
  border-color: var(--brand-button, #2563eb);
}

.filter-count-badge {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-width: 18px;
  height: 18px;
  margin-left: 4px;
  padding: 0 5px;
  border-radius: 9px;
  background: var(--brand-button, #2563eb);
  color: #fff;
  font-size: 11px;
  font-weight: 700;
}`, "",{"version":3,"sources":["webpack://./src/app/shared/listing-browse-ui/browse-filters-layout.scss"],"names":[],"mappings":"AAAA;sEAAA;AAGA;EACE,aAAA;EACA,iBAAA;EACA,mBAAA;EACA,QAAA;EACA,SAAA;EACA,gBAAA;EACA,gBAAA;AAAF;;AAGA;EACE,cAAA;EACA,YAAA;EACA,UAAA;AAAF;;AAGA;EACE,WAAA;AAAF;;AAGA,uDAAA;AACA;EACE,uCAAA;EACA,gDAAA;AAAF;;AAGA;EACE,aAAA;AAAF;;AAGA;EACE,iBAAA;AAAF;;AAGA;EACE,gBAAA;EACA,gBAAA;EACA,mBAAA;AAAF;;AAGA;EACE,aAAA;EACA,iBAAA;EACA,mBAAA;EACA,yBAAA;EACA,QAAA;EACA,cAAA;EACA,oBAAA;EACA,qBAAA;EACA,mBAAA;AAAF;;AAGA;EACE,cAAA;EACA,gBAAA;EACA,gBAAA;EACA,YAAA;EACA,eAAA;AAAF;AAEE;EACE,eAAA;EACA,WAAA;EACA,YAAA;EACA,iBAAA;EACA,sBAAA;AAAJ;;AAIA;EACE,6DAAA;EACA,0CAAA;AADF;;AAIA;EACE,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,eAAA;EACA,YAAA;EACA,gBAAA;EACA,cAAA;EACA,kBAAA;EACA,wCAAA;EACA,WAAA;EACA,eAAA;EACA,gBAAA;AADF","sourcesContent":["/* Shared toolbar styles for app-basic-filter (ViewEncapsulation.None).\n   Page grid / drawer layout lives in listing-browse.component.scss. */\n\n.basic-filter-toolbar {\n  display: flex;\n  flex-wrap: nowrap;\n  align-items: center;\n  gap: 8px;\n  margin: 0;\n  padding: 4px 8px;\n  min-height: 48px;\n}\n\n.basic-filter-toolbar .keyword-search-field {\n  flex: 1 1 auto;\n  min-width: 0;\n  padding: 0;\n}\n\n.basic-filter-toolbar .keyword-field-compact {\n  width: 100%;\n}\n\n/* Collapse Material field chrome to one compact row. */\n.basic-filter-toolbar .keyword-field-compact.mat-mdc-form-field {\n  --mat-form-field-container-height: 40px;\n  --mat-form-field-container-vertical-padding: 8px;\n}\n\n.basic-filter-toolbar .keyword-field-compact .mat-mdc-form-field-subscript-wrapper {\n  display: none;\n}\n\n.basic-filter-toolbar .keyword-field-compact .mat-mdc-text-field-wrapper {\n  padding-bottom: 0;\n}\n\n.basic-filter-toolbar .keyword-field-compact .mat-mdc-form-field-infix {\n  min-height: 40px;\n  padding-top: 8px;\n  padding-bottom: 8px;\n}\n\n.basic-actions {\n  display: flex;\n  flex-wrap: nowrap;\n  align-items: center;\n  justify-content: flex-end;\n  gap: 4px;\n  flex: 0 0 auto;\n  margin: 0 !important;\n  padding: 0 !important;\n  white-space: nowrap;\n}\n\n.all-filters-btn {\n  margin-left: 0;\n  line-height: 1.2;\n  min-height: 36px;\n  height: 36px;\n  padding: 0 10px;\n\n  .mat-icon {\n    font-size: 18px;\n    width: 18px;\n    height: 18px;\n    margin-right: 4px;\n    vertical-align: middle;\n  }\n}\n\n.all-filters-btn.sidebar-mode-active {\n  background: var(--brand-button-soft, rgba(37, 99, 235, 0.18));\n  border-color: var(--brand-button, #2563eb);\n}\n\n.filter-count-badge {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  min-width: 18px;\n  height: 18px;\n  margin-left: 4px;\n  padding: 0 5px;\n  border-radius: 9px;\n  background: var(--brand-button, #2563eb);\n  color: #fff;\n  font-size: 11px;\n  font-weight: 700;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
